<template>
  <w-icon-wrapper
    :height='20'
    :width='20'
    icon-name='work-radio-unselected-icon'
    view-box='0 0 20 20'
  >
    <circle
      id='Radio_Button_Unselected'
      cx='10'
      cy='10'
      data-name='Radio Button Unselected'
      fill='currentColor'
      r='10'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconRadioUnselected' };
</script>
